import { render } from "./SVGLamp.vue?vue&type=template&id=74637378"
import script from "./SVGLamp.vue?vue&type=script&lang=js"
export * from "./SVGLamp.vue?vue&type=script&lang=js"

import exportComponent from "/Users/vladimirkurockin/Projects/NowMedia/wardrobe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__